import { Text } from '@myinterview/component-library';
import classNames from 'classnames';
import React from 'react';
import { ALL_JOB_QUESTIONS_TYPE, ANSWER_TYPES } from '../interfaces/jobInterface';
import { QuestionParameters } from './QuestionParamaters';

interface IProps {
  questionObj: ALL_JOB_QUESTIONS_TYPE;
  isInner?: boolean;
}

export const Question:React.FC<IProps> = ({ questionObj, isInner = false }) => {
  const questionClassNames = classNames({
    'myinterview-widget-question': true,
    'myinterview-widget--rtl-support': true,
    'myinterview-widget-question--inner': isInner,
  });
  return (
    <div className={questionClassNames}>
      <QuestionParameters answerType={questionObj.answerType || ANSWER_TYPES.VIDEO} duration={questionObj.partDuration} takes={questionObj.numOfRetakes} />
      <Text className="myinterview-widget-question__question" size="M-Bold">{questionObj.question}</Text>
      <Text className="myinterview-widget-question__description" size="S-Regular" color="neutral-50">{questionObj.description}</Text>
    </div>
  );
};
